import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FieldFooter } from '../FieldFooter';
import { MediaCard } from '../MediaCard';
import { Checkbox, CheckboxLabel, Wrapper } from './Checkbox.styles';
export const CheckboxCard = /*#__PURE__*/ forwardRef(({ activeValues, hasError, label, mediaProperties, name, statusMessage, value, ...props }, ref)=>{
    const id = value ? `${name}_${value}` : name;
    return /*#__PURE__*/ _jsx(MediaCard, {
        htmlFor: id,
        isActive: typeof activeValues === 'boolean' ? activeValues : activeValues?.includes(value),
        mediaProperties: mediaProperties,
        children: /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsx(Checkbox, {
                    id: id,
                    name: name,
                    value: value,
                    ...props,
                    $state: hasError ? 'error' : 'default',
                    ref: ref
                }),
                /*#__PURE__*/ _jsxs(CheckboxLabel, {
                    isBold: true,
                    renderAs: 'span',
                    children: [
                        label,
                        /*#__PURE__*/ _jsx(FieldFooter, {
                            fieldFooterLabel: statusMessage
                        })
                    ]
                })
            ]
        })
    });
});

//# sourceMappingURL=CheckboxCard.js.map